import { render, staticRenderFns } from "./SponsoredLoans.vue?vue&type=template&id=3576486d"
import script from "./SponsoredLoans.vue?vue&type=script&lang=js"
export * from "./SponsoredLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports